import React from 'react';
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useColorModeValue,
} from '@chakra-ui/react';

import { TermsAndConditionsContent } from 'clipsal-cortex-ui/src/components/TermsAndConditionsContent';

import { ModalProps } from '../../common/types/types';

export function TermsAndConditionsModal({ isOpen, onClose }: ModalProps) {
  const buttonColorScheme = useColorModeValue('customBlack', 'whiteAlpha');
  return (
    <Modal scrollBehavior={'inside'} size={'xl'} isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent data-testid="termsConditionsModalBody">
        <ModalHeader>Terms & Conditions</ModalHeader>
        <ModalCloseButton data-testid="termsConditionsCloseBtn" />
        <ModalBody>
          <TermsAndConditionsContent />
        </ModalBody>

        <ModalFooter>
          <Button colorScheme={buttonColorScheme} color="white" mr={3} onClick={onClose}>
            Got it
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
